import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';

export const dimensions = {
  mobile: {
    width: 80,
  },
  desktop: {
    width: 42,
  },
};

export const FullScreenGalleryContainerSt = styled.div`
  display: flex;
  z-index: 100;
  flex-direction: row;
  max-width: 100%;
  justify-content: center;
  margin: 1rem auto 1rem auto;
  ${media.sm(
    css`
      min-width: 80px;
      flex-direction: column;
      max-height: 80%;
      margin: auto 1rem auto 1rem;
      align-items: center;
      min-width: 100px;
      max-width: 100px;
    `,
  )}
`;

export const FullScreenGalleryInnerContainerSt = styled.div`
  display: flex;
  max-height: 80px;
  overflow: hidden;
  z-index: 100;
  flex-direction: row;
  gap: 1rem;
  ${media.sm(
    css`
      max-height: 100%;
      min-width: 50px;
      flex-direction: column;
    `,
  )}
`;

const FullScreenGalleryButton = styled.button`
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  background: transparent;
  border: none;
  margin: auto;
  min-width: 50px;
  ${media.sm(css`
    min-width: auto;
    min-height: 50px;
  `)};
`;

export const FullScreenGalleryPreviousButton = styled(FullScreenGalleryButton)`
  & > svg {
    ${media.sm(css`
      transform: rotate(90deg);
    `)};
  }
`;

export const FullScreenGalleryNextButton = styled(FullScreenGalleryButton)`
  & > svg {
    ${media.sm(css`
      transform: rotate(90deg);
    `)}
  }
`;
